import React from 'react';
import styles from './AtpUpdateBanner.scss';
import CSSModules from "react-css-modules";
import { MySunbitBanner } from "../../../components/banners/MySunbitBanner/mySunbitBanner";
import bannerIcon from '../../../static/images/launch_img.svg';
import PropTypes from "prop-types";
import {injectIntl, intlShape} from "react-intl";

@injectIntl
@CSSModules(styles, {allowMultiple: true})
class AtpUpdateBanner extends React.Component {
  static propTypes = {
    intl: intlShape,
    firstName : PropTypes.string.isRequired,
    onApplyClick : PropTypes.func.isRequired,
    onCloseBanner : PropTypes.func.isRequired,
    isOpen : PropTypes.bool
  };

  constructor(props) {
    super(props);
  }
    getHeaderComponent(){
      return (
        <div className={styles.mainText}>
          {this.props.intl.formatMessage({id:'atpUpdate.updateBanner.mainText'},{firstName:this.props.firstName})}
        </div>
      );
    }
  render() {
    const { formatMessage} = this.props.intl;

    return (
      <MySunbitBanner note={''}
                      isImgFit={true}
                      isOpen={!!this.props.isOpen}
                      name={'atp-update-banner'}
                      onExit={this.props.onCloseBanner}
                      applyClicked={this.props.onApplyClick}
                      smallHeader={''}
                      header={this.getHeaderComponent()}
                      imgSrc={bannerIcon}
                      buttonText={formatMessage({id:'atpUpdate.updateBanner.actionBtn'})}/>
    );

  }
}

export default AtpUpdateBanner;





// WEBPACK FOOTER //
// ./src/card/CardDialogs/AtpUpdateBanner/AtpUpdateBanner.js